import { format, parseISO } from 'date-fns'

/**
 * Expects ISO date string
 */
const formatDate = dateStr => format(parseISO(dateStr), 'MMM d, YYY')

/**
 * Expects just the date as 'dd/mm/yyyy'. day and month can be just a single
 * digit and need to be padded for parseISO to work.
 */
const formatShortDate = dateStr => {
  return format(
    parseISO(
      dateStr
        .split('/')
        .reverse()
        .map((part, index) => (index === 0 ? part : part.padStart(2, '0')))
        .join('-')
    ),
    'MMM d, YYY'
  )
}

const formatLongDate = dateStr => {
  return format(
    parseISO(
      dateStr
        .split('/')
        .reverse()
        .map((part, index) => (index === 0 ? part : part.padStart(2, '0')))
        .join('-')
    ),
    'MMMM d, yyyy'
  )
}

const parseUnit = (duration, unit, trial = false) => {
  if (duration === 1 && unit.endsWith('s')) {
    return trial ? `${duration} ${unit.slice(0, -1)}` : unit.slice(0, -1)
  }
  return `${duration} ${unit}`
}

export { formatDate, formatShortDate, formatLongDate, parseUnit }
